<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="创建人">
          <ThrottleSelector v-model="agentId" :list="agentData" style="width: 160px" placeholder="全部" filterable clearable />
        </ElFormItem>
        <ElFormItem label-width="38">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="open">新增创意标签组</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
import { getSysMember } from '@/api/common.model'
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'labelFilter',
  components: { ThrottleSelector },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      let params = {
        opId: this.agentId === '' ? undefined : this.agentId
      }
      params = Object.assign(params, { keyword: this.keyword === '' ? undefined : this.keyword })
      this.$emit('on-change', params)
    },
    search() {
      let params = {
        opId: this.agentId === '' ? undefined : this.agentId
      }
      params = Object.assign(params, { keyword: this.keyword === '' ? undefined : this.keyword })
      this.$emit('on-search', params)
    },
    proloadData() {
      Promise.all([getSysMember()])
        .then((data) => {
          const [agentData] = data
          isArray(agentData) && (this.agentData = agentData)
          if (isEmpty(parseInt(getCookie('ch_op_id')))) this.sendEvent()
          else this.agentId = parseInt(getCookie('ch_op_id'))
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    open() {
      this.$emit('on-set')
    }
  },
  watch: {
    agentId(nVal) {
      this.sendEvent()
    }
  },
  data() {
    return {
      keyword: '',
      agentId: '',
      agentData: []
    }
  },
  created() {
    this.proloadData()
  }
}
</script>
